// TOOD actually implement or delete

import useMutationApi from 'src/api/useMutationApi';

interface RequestBody {
  sku?: string;
  itemName?: string;
  quantity?: number;
  unitPrice?: number;
  description?: string;
  customerIdentifier?: string;
  customerDescription?: string;
}

const useCreateSalesOrderDraftLineItem = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  return useMutationApi<RequestBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/line-items`,
    method: 'POST',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useCreateSalesOrderDraftLineItem;
